import React from 'react';
import { CreativeCanvasEngine } from '../engine/CreativeCanvasEngine';

export default function CreativePreviewBubble({ structure }) {
  if (!structure || typeof structure !== 'object') return null;

  if ((structure.type === 'design' && structure.canvas_data) || (structure.type === 'carousel' && Array.isArray(structure.slides))) {
    return (
      <CreativeCanvasEngine structure={structure} />
    );
  }

  if (structure.type === 'image' && structure.image_url) {
    const hasEditorCopy = !!(structure.headline || structure.legenda || structure.publico_alvo || structure.cta);
    return (
      <div className="creative-preview-bubble creative-preview-bubble--image">
        {structure.watermark?.enabled ? (
          <span className="creative-preview-bubble__watermark">{structure.watermark.text || 'Criado com Marketing Pro'}</span>
        ) : null}
        <img src={structure.image_url} alt={structure.headline || 'Preview gerado'} />
        {hasEditorCopy && (
          <div className="creative-preview-bubble__copy">
            {structure.headline && <h3 className="creative-preview-bubble__headline">{structure.headline}</h3>}
            {structure.legenda && <p className="creative-preview-bubble__legenda">{structure.legenda}</p>}
            {structure.cta && <span className="creative-preview-bubble__cta">{structure.cta}</span>}
            {structure.publico_alvo && <span className="creative-preview-bubble__audience">Público: {structure.publico_alvo}</span>}
          </div>
        )}
      </div>
    );
  }

  const videoUrl = structure.video_url || structure.url;
  if (structure.type === 'video' && videoUrl) {
    return (
      <div className="creative-preview-bubble creative-preview-bubble--video">
        <video src={videoUrl} controls playsInline preload="metadata" />
      </div>
    );
  }

  return null;
}
